<script>

import moment from 'moment';
import moneyUtils from '../../../../../../../utils/money';

export default {
  name: 'TransactionDisplayUtils',
  methods: {
    getTransactionAmount(transaction) {
      const amount = transaction.incomeAmount > 0 ? transaction.incomeAmount : transaction.billingAmount;
      return moneyUtils.formatAmountWithFraction(amount);
    },
    formatAmount(amount) {
      return !_.isNil(amount) ? `${amount} ₪` : amount;
    },
    formatAmountWithFractionAndCurrency(number, fractionDigits = 0) {
      return this.formatAmount(moneyUtils.formatAmountWithFraction(number, fractionDigits));
    },
    formatDate(date) {
      return moment(date).format('D.M.YY');
    },
    getTransactionAccount(transaction) {
      const transactionFrom = transaction.sourceType === 'checkingAccount' ? 'חשבון' : 'כרטיס';
      return `${transactionFrom} ${transaction.account}`;
    },
    getTransactionPayment(transaction) {
      return transaction.paymentNumber > 0 ? `- תשלום${transaction.paymentNumber}/${transaction.totalNumberOfPayments}` : '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/TransactionDisplayUtils.vue